/**
 * 格式化时间戳 yyyy-MM-dd HH:mm:ss
 * @param {Date}
 * @returns  {yyyy-MM-dd HH:mm:ss}
 */

 export function formatTime(date) {
  let t = new Date(date);
  let y = String(t.getFullYear());
  let mon = String(t.getMonth() + 1).padStart(2, "0");
  let d = String(t.getDate()).padStart(2, "0");
  let h = String(t.getHours()).padStart(2, "0");
  let m = String(t.getMinutes()).padStart(2, "0");
  let s = String(t.getSeconds()).padStart(2, "0");
  return `${y}-${mon}-${d} ${h}:${m}:${s}`;
}

/**
 * 格式化时间戳 yyyy-MM-dd
 * @param {Date|Number} date
 * @returns  {string} "yyyy-MM-dd"
 */

export function formatDate(date) {
  if (date + "" === "") return "";
  let t = new Date(date);
  let y = String(t.getFullYear());
  let mon = String(t.getMonth() + 1).padStart(2, "0");
  let d = String(t.getDate()).padStart(2, "0");
  return `${y}-${mon}-${d}`;
}

/**
 * 获取昨日日期
 * @returns {yyyy-MM-dd}
 */
export function getYesterdayDate() {
  let t = new Date();
  t.setTime(t.getTime() - 24 * 60 * 60 * 1000);
  let y = String(t.getFullYear());
  let mon = String(t.getMonth() + 1).padStart(2, "0");
  let d = String(t.getDate()).padStart(2, "0");
  return `${y}-${mon}-${d}`;
}

/**
 * 获取今日日期
 * @returns {yyyy-MM-dd}
 */
export function getTodayDate() {
  let t = new Date();
  let y = String(t.getFullYear());
  let mon = String(t.getMonth() + 1).padStart(2, "0");
  let d = String(t.getDate()).padStart(2, "0");
  return `${y}-${mon}-${d}`;
}

/**
 * 获取明日日期
 * @returns {yyyy-MM-dd}
 */
export function getTomorrowDate() {
  let t = new Date();
  t.setTime(t.getTime() + 24 * 60 * 60 * 1000);
  let y = String(t.getFullYear());
  let mon = String(t.getMonth() + 1).padStart(2, "0");
  let d = String(t.getDate()).padStart(2, "0");
  return `${y}-${mon}-${d}`;
}

/**
 * 获取当前月份
 * @returns {yyyy-MM}
 */
export function getCurrentMonth() {
  let t = new Date();
  let y = String(t.getFullYear());
  let mon = String(t.getMonth() + 1).padStart(2, "0");
  return `${y}-${mon}`;
}

/**
 * 格式化时长
 * @param {Number} time 时长（秒）
 * @param {Boolean} hideZero 隐藏0值
 * @param {String} format 格式化
 * @returns {String}
 */
export function formatDuration(time, hideZero = true, format = "dhms") {
  let d, h, m, s;
  d = ~~(time / 86400);
  time -= d * 86400;
  h = ~~(time / 3600);
  time -= h * 3600;
  m = ~~(time / 60);
  s = time % 60;
  format = format.replace("d", d || !hideZero ? `${d}天` : "");
  format = format.replace("h", h || !hideZero ? `${h}小时` : "");
  format = format.replace("m", m || !hideZero ? `${m}分` : "");
  format = format.replace("s", s || !hideZero ? `${s}秒` : "");
  if (!format) format = "0";
  return format;
}

/**
 * 日期的快捷日期
 * @returns
 */
export function shortcuts() {
  return [
    {
      text: "今天",
      onClick(picker) {
        picker.$emit("pick", [new Date(), new Date()]);
      },
    },
    {
      text: "昨天",
      onClick(picker) {
        const date = new Date();
        date.setTime(date.getTime() - 3600 * 1000 * 24);
        picker.$emit("pick", [date, date]);
      },
    },
    {
      text: "一周前",
      onClick(picker) {
        const date = new Date();
        date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit("pick", [date, new Date()]);
      },
    },
  ];
}

/**
 * 获取前几天的日期
 * @param {number} amount 取值大于等于0，默认为0
 * @returns {String} yyyy-MM-dd
 */
export function getLastFewDays(amount = 0) {
  if (typeof amount !== "number" || amount <= 0) return this.getTodayDate();
  const lastFewDayTimestamp = new Date().getTime() - amount * 1000 * 60 * 60 * 24;
  return formatDate(lastFewDayTimestamp);
}

/**
 * 根据传入的日期获取月日
 * @param {*} date
 * @returns {String} MM-dd
 */
export function getMonthAndDate(date) {
  const t = new Date(date);
  const mon = String(t.getMonth() + 1).padStart(2, "0");
  const d = String(t.getDate()).padStart(2, "0");
  return `${mon}-${d}`;
}

/**
 * 根据传入的日期获取时分
 * @param {*} date
 * @returns {String} HH:mm
 */
export function getHourAndMinutes(date) {
  const t = new Date(date);
  const hour = String(t.getHours()).padStart(2, "0");
  const minutes = String(t.getMinutes()).padStart(2, "0");
  return `${hour}:${minutes}`;
}
